import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../../../actions/CauHinhGoiTraGop";
import { pushNotification } from "utils/notifications";
import BanHangTraGopApi from "service/banHangTraGopApi";

export const ModalMoKhoa = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    Id: 0,
    TenSanPham: "",
    TrangThai: true,
  };
  const [dataCauHinh, setDataCauHinh] = useState(initData);
  useEffect(() => {
    if (props.Id > 0) {
      setDataCauHinh({
        ...dataCauHinh,
        TenSanPham: props.item.TenSanPham,
        Id: props.Id,
        TrangThai: true,
      });
    }
  }, []);

  const onSubmit = () => {
    const value = { ...dataCauHinh };

    if (props.Id > 0) {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiTraGop(params).then((response) => {
        if (response.status == 200) {
          pushNotification(
            "Bạn đã mở khoá sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          props.onHide();
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-lock-open-variant"></i>
          </span>{" "}
          <span>Mở khoá</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label className="col-md-12 label-control text-center">
                  Bạn có chắc chắn muốn mở khóa sản phẩm{" "}
                  <span className="red">{dataCauHinh.TenSanPham}</span> không?
                </label>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
          disabled={isSubbmit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>{" "}
          &nbsp; Xác nhận &nbsp;
        </button>
        &nbsp;
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          &nbsp; Đóng &nbsp;
        </a>
      </Modal.Footer>
    </Modal>
  );
};
